import React from 'react';
import DatesScroller from '../common/DatesScroller';
import styled, { css } from 'styled-components';
import { breakpoints } from '../../utils/styles';

const PaddedContainer = styled.div`
  background: var(--tertiary);
  padding: 1rem 0 1rem var(--pad-x);
`;

class BillboardSidebarDates extends React.Component {
  constructor(props) {
    super(props);

    this.onDateSelect = this.onDateSelect.bind(this);
  }

  shouldComponentUpdate(nextProps) {
    return this.props.selectedDate !== nextProps.selectedDate
        || this.props.dates.join(',') !== nextProps.dates.join(',');
  }

  onDateSelect(date) {
    const dateYmd = date.replace(/-/g, '')
    
    this.props.onDateSelect(dateYmd);
  }

  render() {
    const {dates} = this.props;

    if (!dates || !dates.length) {
      return '';
    }

    return (
        <PaddedContainer>
          <DatesScroller dates={dates} selectedDate={this.props.selectedDate} onDateSelect={this.onDateSelect} />
        </PaddedContainer>
    );
  }
}

export default BillboardSidebarDates;